import { getEventKey, type HubEvent } from '../data';
import s from '../page.module.scss';
import { HubEventCard } from './HubEventCard';

interface HubEventCardGridProps {
  events: HubEvent[];
}

export function HubEventCardGrid({ events }: HubEventCardGridProps) {
  if (events.length === 0) return null;

  return (
    <ul className={s.card_grid}>
      {events.map((event) => (
        <HubEventCard key={getEventKey(event)} event={event} />
      ))}
    </ul>
  );
}
